__turbopack_context__.v({
  "dock": "dock-module__teT_-q__dock",
  "dockAlignCenter": "dock-module__teT_-q__dockAlignCenter",
  "dockAlignEnd": "dock-module__teT_-q__dockAlignEnd",
  "dockAlignStart": "dock-module__teT_-q__dockAlignStart",
  "dockHorizontal": "dock-module__teT_-q__dockHorizontal",
  "dockIcon": "dock-module__teT_-q__dockIcon",
  "dockIconInner": "dock-module__teT_-q__dockIconInner",
  "dockVertical": "dock-module__teT_-q__dockVertical",
});
